// @ts-nocheck

import LazyLoad from 'vanilla-lazyload';

class LazyLoadImagesHelper {
  lazyLoadInstance = undefined;

  init() {
    this.lazyLoadInstance = new LazyLoad({
      elements_selector: '.lazy',
    });
  }

  update() {
    if (this.lazyLoadInstance !== undefined) {
      this.lazyLoadInstance.update();
    }
  }

  loadImagesInElement(htmlElement: HTMLElement) {
    if (this.lazyLoadInstance !== undefined && htmlElement !== null) {
      LazyLoad.load(htmlElement, {});
    }
  }
}

export default new LazyLoadImagesHelper();
